import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppHelper } from "src/app/helpers/app.helper";
import { AppConfigService } from "src/app/services/app.config.service";
import { NotificationService } from "src/app/services/notification.service";
import { SettingsDialogService } from "src/app/services/settings-dialog.service";
import { MenuSettingsComponent } from "./menu/settings.component";



@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],

})
export class MenuComponent implements OnInit, OnDestroy {
  @Input() showMenuGuest!: boolean;

  @Output() showSessionInfo = new EventEmitter<boolean>;
  @Output() showCitizenInfo = new EventEmitter<boolean>;
  
  // AppHelper = AppHelper;
  // NotificationService = NotificationService;
  title =  AppHelper.getTitleName();

  // LANGUAGES = Constants.LANGUAGES_LIST;
  // selectedLang = Constants.DEFAULTLANGUAGE;

  private destroy$ = new Subject<void>();
  private settingsDialogRef?: MatDialogRef<MenuSettingsComponent>;

  constructor(
    public config: AppConfigService,
    private settingsDialogService: SettingsDialogService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    // Sottoscrivi alle richieste di apertura settings
    this.settingsDialogService.openSettings$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showSettings();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  shownCredits=false;
  
  public showCredits() {
    this.shownCredits = true;
    // NotificationService.showElement(this.credits.nativeElement, '').then(() =>{this.shownCredits=false;});
    NotificationService.showCredits();
  }

  shownSettings=false;
  
  public showSettings() {
    // Se il dialog è già aperto, non fare nulla
    if (this.settingsDialogRef && this.settingsDialogRef.componentInstance) {
      return;
    }
    
    // Apri il dialog usando MatDialog
    this.settingsDialogRef = this.dialog.open(MenuSettingsComponent, {
      width: '90%',
      maxWidth: '800px',
      height: 'auto',
      maxHeight: 'min(90dvh, 90vh)',
      disableClose: true,
      panelClass: 'settings-dialog-panel'
    });
    
    // Gestisci la chiusura del dialog
    this.settingsDialogRef.afterClosed().subscribe(result => {
      // result sarà true se è stato cliccato OK, false se Cancel o X
      if (!result) {
        console.log('Settings dialog chiuso con Cancel o X - modifiche annullate');
      } else {
        console.log('Settings dialog chiuso con OK - modifiche salvate');
      }
      this.settingsDialogRef = undefined;
    });
  }

  public toggleShowSessionInfo() {
    this.showSessionInfo.emit(true);//this._toggleShowSessionInfo); // visualizza sempre al click
  }
  public toggleShowCitizenInfo() {
    this.showCitizenInfo.emit(true);//this._toggleShowSessionInfo); // visualizza sempre al click
  }

  close() {
      NotificationService.popupClose();
  }
}